import { LineData, Time } from 'lightweight-charts'

export type MultiStrikeSeriesSnapshot = Record<string, LineData<Time>>

function lineDataEqual(a?: LineData<Time>, b?: LineData<Time>): boolean {
    if (a === b) return true
    if (!a || !b) return false
    return a.time === b.time && a.value === b.value
}

export function multiStrikeSnapshotChangedKeys(
    prev: MultiStrikeSeriesSnapshot | undefined,
    next: MultiStrikeSeriesSnapshot
): string[] {
    const keys = new Set([...Object.keys(prev ?? {}), ...Object.keys(next)])
    const changed: string[] = []
    keys.forEach((key) => {
        if (!lineDataEqual(prev?.[key], next[key])) {
            changed.push(key)
        }
    })
    return changed
}
